import PropTypes from 'prop-types';
import React from 'react';

export const GreenToRedCandlesWrapper = ({ softOrder, Component, ...rest }) => {
  const details = {
    tacticName: 'GREEN_TO_RED_CANDLES',
    category: 'Exit',
    type: 'Green to Red Candles',
    domain: 'Underlying',
  };
  const state = softOrder.state;
  //depending on state, either right direction pct is sent or retrace is sent
  const inRightDirectionPct = softOrder.inRightDirectionPct;
  const retracePct = softOrder.retracePct;
  const priceToBreak = softOrder.priceToBreak;
  const candleDuration = softOrder.candleDuration;

  return (
    <Component
      details={details}
      state={state}
      candleDuration={candleDuration}
      priceToBreak={priceToBreak}
      inRightDirectionPct={inRightDirectionPct}
      retracePct={retracePct}
      {...rest}
    />
  );
};

GreenToRedCandlesWrapper.propTypes = {
  Component: PropTypes.any,
  softOrder: PropTypes.shape({
    candleDuration: PropTypes.any,
    inRightDirectionPct: PropTypes.any,
    priceToBreak: PropTypes.any,
    retracePct: PropTypes.any,
    state: PropTypes.any
  })
};



